import { Component, ElementRef, Input, OnInit, SimpleChanges, ViewChild } from "@angular/core";
import { CrackHistory, MonthHeader } from "../../dashboard.model";
import { GETDashboardService } from "../../dashboard.service";
import { SearchFilters } from "../../search-panel/search-panel.model";
import { GETPreferencesService } from "../../../preferences/preferences.service";
import { Router } from "@angular/router";
import { NotificationsService } from "angular2-notifications";
import * as XLSX from "xlsx";
@Component({
  selector: "app-implements-crack-view-new",
  templateUrl: "./implements-crack-view-new.component.html",
  styleUrls: ["./implements-crack-view-new.component.scss"],
})
export class ImplementsCrackViewNewComponent implements OnInit {
  @Input() filters!: SearchFilters;
  @ViewChild("tableScroll") tableScroll!: ElementRef;
  @ViewChild("topScroll") topScroll!: ElementRef;
  @ViewChild("dataTable") dataTable!: ElementRef;
  groupedData: any[] = [];
  months: MonthHeader[] = [];
  selectedMonths: number = 0;
  loading: boolean = false;
  userUOM: string = "mm";
  showCracks: boolean = true;
  showLength: boolean = true;
  showRecracks: boolean = true;
  tableWidth: number = 0;
  monthTotals: any[] = [];
  constructor(
    private _getService: GETDashboardService,
    private _userPref: GETPreferencesService,
    private _router: Router,
    private _notify: NotificationsService,
  ) {}

  ngOnInit(): void {
    this.getUserPref();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["filters"] && this.filters) {
      this.loadData();
    }
  }

  ngAfterViewInit() {
    const top = this.topScroll?.nativeElement;
    const bottom = this.tableScroll?.nativeElement;
    if (!top || !bottom) return;
    top.addEventListener("scroll", () => {
      bottom.scrollLeft = top.scrollLeft;
    });
    bottom.addEventListener("scroll", () => {
      top.scrollLeft = bottom.scrollLeft;
    });
  }

  ngAfterViewChecked() {
    if (this.dataTable?.nativeElement) {
      const width = this.dataTable.nativeElement.scrollWidth;

      if (width && width !== this.tableWidth) {
        this.tableWidth = width;
      }
    }
  }

  savePreferences(isSelected: boolean) {
    const payload = {
      Month: this.selectedMonths,
      ShowCracks: this.showCracks,
      ShowLength: this.showLength,
      ShowRecracks: this.showRecracks,
    };

    this._getService.saveCrackPreferences(payload).subscribe({
      next: () => console.log("Preferences saved"),
      error: (err) => console.error(err),
    });
    if (isSelected) this.loadData();
  }

  loadData() {
    const payload: SearchFilters = {
      ...this.filters,
      Level: 1,
      Months: this.selectedMonths ?? 0,
    };
    this.loading = true;
    this._getService.GetCrackView(payload).subscribe({
      next: (res) => {
        console.log("Crack View Data:", res);
        if (res?.Data?.length === 0) {
          this._notify.warn("No Record Found");
        }
        this.months = res?.Months;
        this.selectedMonths = res?.Months?.length;
        this.showCracks = res?.Data[0]?.ShowCracks ?? true;
        this.showLength = res?.Data[0]?.ShowCrackLength ?? true;
        this.showRecracks = res?.Data[0]?.ShowRecrack ?? true;
        this.groupedData = this.groupLevel1(res?.Data);
        this.calculateMonthTotals();
        this.getUserPref();
        this.loading = false;
      },
      error: () => (this.loading = false),
    });
  }

  groupLevel1(data: CrackHistory[]) {
    return data.map((item) => ({
      Family: item.Family,
      Model: item.Model,
      UnitNo: item.UnitNo,
      componentTypeCount: item.ComponentTypeCount,
      Months: item.Months || [],
      expanded: false,
      loading: false,
      childrenLoaded: false,
      componentTypes: [],
      GETId: item.GETId,
    }));
  }

  toggleUnit(row: any) {
    row.expanded = !row.expanded;
    if (row.expanded && !row.childrenLoaded) {
      row.loading = true;
      const payload: SearchFilters = {
        ...this.filters,
        Level: 2,
        UnitNo: row.UnitNo,
        ComponentType: null,
        Months: this.selectedMonths,
      };
      this._getService.GetCrackView(payload).subscribe({
        next: (res) => {
          row.componentTypes = this.groupLevel2(res.Data);
          row.childrenLoaded = true;
          row.loading = false;
          this.getUserPref();
        },
        error: () => (row.loading = false),
      });
    }
  }

  groupLevel2(data: CrackHistory[]) {
    return data.map((item) => ({
      ComponentTypeName: item.ComponentTypeName,
      componentCount: item.ComponentCount,
      Months: item.Months || [],
      expanded: false,
      loading: false,
      childrenLoaded: false,
      components: [],
    }));
  }

  toggleComponentType(parent: any, row: any) {
    if (!row) return;
    row.expanded = !row.expanded;
    if (row.expanded && !row.childrenLoaded) {
      row.loading = true;
      const payload: SearchFilters = {
        ...this.filters,
        Level: 3,
        UnitNo: parent.UnitNo,
        ComponentType: row.ComponentTypeName,
        Months: this.selectedMonths,
      };
      this._getService.GetCrackView(payload).subscribe({
        next: (res) => {
          row.components = (res.Data || []).map((item) => ({
            ComponentName: item.ComponentName,
            ObsPointCount: item.ObsPointCount,
            Months: item.Months || [],
          }));
          this.getUserPref();
          row.childrenLoaded = true;
          row.loading = false;
        },
        error: () => (row.loading = false),
      });
    }
  }

  getUserPref() {
    this._userPref.getUserPreferences().subscribe((res) => {
      this.userUOM = res.UnitOfMeasurementName;
    });
  }

  formatLength(value: number | null | undefined): string {
    if (!value || value === 0) return "";

    return value.toLocaleString("en-AU", {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    });
  }

  getVisibleColumnCount(): number {
    let count = 0;
    if (this.showCracks) count++;
    if (this.showLength) count++;
    if (this.showRecracks) count++;
    return count || 1;
  }

  getMonthClass(): string {
    if (this.months?.length <= 3) return "month-3";
    if (this.months?.length <= 6) return "month-6";
    return "month-12";
  }

  openInNewTab(id: number) {
    const url = this._router.serializeUrl(
      this._router.createUrlTree(["/implementdetails", id]),
    );
    window.open(url, "_blank");
  }

  calculateMonthTotals() {
    const totals: any = {};
    this.groupedData.forEach((row) => {
      row.Months?.forEach((m: any, index: any) => {
        if (!totals[index]) {
          totals[index] = {
            TotalCracks: 0,
            TotalLength: 0,
            TotalRecracks: 0,
          };
        }
        totals[index].TotalCracks += m.TotalCracks || 0;
        totals[index].TotalLength += m.TotalLength || 0;
        totals[index].TotalRecracks += m.TotalRecracks || 0;
      });
    });

    this.monthTotals = Object.values(totals);
  }

  excelDownload: boolean = false;
  exportExcelFromAPI() {
    this.excelDownload = true;
    this._getService
      .GetCrackExcelView({
        ...this.filters,
        Months: this.selectedMonths,
      })
      .subscribe({
        next: (res) => {
          if (!res?.Data?.length) {
            this._notify.warn("No Record Found");
            this.excelDownload = false;
            return;
          }
          this.months = res.Months;
          const hierarchy = this.buildHierarchy(res.Data);
          const rows = this.buildRowsFromFlat(hierarchy);
          const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(rows);
          const dynamicCols: any[] = [];
          this.months.forEach(() => {
            if (this.showCracks) dynamicCols.push({ wch: 12 });
            if (this.showLength) dynamicCols.push({ wch: 15 });
            if (this.showRecracks) dynamicCols.push({ wch: 12 });
          });
          ws["!cols"] = [{ wch: 20 }, { wch: 20 }, { wch: 25 }, ...dynamicCols];
          const merges: XLSX.Range[] = [];

          // Static columns
          merges.push(XLSX.utils.decode_range("A1:A2"));
          merges.push(XLSX.utils.decode_range("B1:B2"));
          merges.push(XLSX.utils.decode_range("C1:C2"));
          merges.push(XLSX.utils.decode_range("D1:D2"));
          merges.push(XLSX.utils.decode_range("E1:E2"));

          let col = 5;
          const span = this.getVisibleColumnCount();

          this.months.forEach(() => {
            if (span > 1) {
              merges.push({
                s: { r: 0, c: col },
                e: { r: 0, c: col + span - 1 },
              });
            }
            col += span;
          });
          ws["!merges"] = merges;
          const wb: XLSX.WorkBook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "Crack Report");
          XLSX.writeFile(wb, "Crack_Report.xlsx");
          this.excelDownload = false;
        },
        error: () => {
          this.excelDownload = false
          this._notify.error("Error exporting data");
        },
      });
  }

  calculateTotalsFromFlat(data: any[]) {
    const totals: any = {};

    data.forEach((unit) => {
      // Only Level 1 (unit level)
      unit.Months?.forEach((m: any) => {
        if (!totals[m.MonthNo]) {
          totals[m.MonthNo] = {
            TotalCracks: 0,
            TotalLength: 0,
            TotalRecracks: 0,
          };
        }

        totals[m.MonthNo].TotalCracks += m.TotalCracks || 0;
        totals[m.MonthNo].TotalLength += m.TotalLength || 0;
        totals[m.MonthNo].TotalRecracks += m.TotalRecracks || 0;
      });
    });

    return totals;
  }
  buildHierarchy(data: any[]) {
    const map = new Map();

    data.forEach((row) => {
      const key = `${row.Family}_${row.Model}_${row.UnitNo}`;

      if (!map.has(key)) {
        map.set(key, {
          Family: row.Family,
          Model: row.Model,
          UnitNo: row.UnitNo,
          Months: [],
          componentTypes: [],
        });
      }

      const unit = map.get(key);

      if (row.Level === 1) {
        unit.Months.push(row);
      }

      if (row.Level === 2) {
        let ct = unit.componentTypes.find(
          (x) => x.ComponentTypeName === row.ComponentTypeName,
        );

        if (!ct) {
          ct = {
            ComponentTypeName: row.ComponentTypeName,
            Months: [],
            components: [],
          };
          unit.componentTypes.push(ct);
        }

        ct.Months.push(row);
      }

      if (row.Level === 3) {
        let ct = unit.componentTypes.find(
          (x) => x.ComponentTypeName === row.ComponentTypeName,
        );

        if (!ct) {
          ct = {
            ComponentTypeName: row.ComponentTypeName,
            Months: [],
            components: [],
          };
          unit.componentTypes.push(ct);
        }

        let comp = ct.components.find(
          (x) => x.ComponentName === row.ComponentName,
        );

        if (!comp) {
          comp = {
            ComponentName: row.ComponentName,
            Months: [],
          };
          ct.components.push(comp);
        }

        comp.Months.push(row);
      }
    });

    return Array.from(map.values());
  }

  buildRowsFromFlat(data: any[]): any[][] {
    const rows: any[][] = [];
    const h1 = ["FAMILY", "MODEL", "UNIT NO", "ComponentType", "ComponentName"];
    this.months.forEach((m) => {
      const span = this.getVisibleColumnCount();
      for (let i = 0; i < span; i++) {
        h1.push(m.MonthName.toUpperCase());
      }
    });
    rows.push(h1);
    const h2 = ["", "", "", "", ""];

    this.months.forEach(() => {
      if (this.showCracks) h2.push("CRACKS");
      if (this.showLength) h2.push("LENGTH");
      if (this.showRecracks) h2.push("RECRACKS");
    });
    rows.push(h2);
    const totals = this.calculateTotalsFromFlat(data);

    const totalRow = ["", "", "", "", "TOTAL"];

    this.months.forEach((m) => {
      const t = totals[m.MonthNo] || {};

      if (this.showCracks) totalRow.push(t.TotalCracks || 0);
      if (this.showLength) totalRow.push(t.TotalLength || 0);
      if (this.showRecracks) totalRow.push(t.TotalRecracks || 0);
    });
    rows.push(totalRow);
    data.forEach((unit) => {
      rows.push(
        this.buildFlatRow(
          unit.Family,
          unit.Model,
          unit.UnitNo,
          "",
          "",
          unit.Months,
        ),
      );
      unit.componentTypes.forEach((ct) => {
        rows.push(
          this.buildFlatRow("", "", "", ct.ComponentTypeName, "", ct.Months),
        );
        ct.components.forEach((c) => {
          rows.push(
            this.buildFlatRow("", "", "", "", c.ComponentName, c.Months),
          );
        });
      });

      rows.push([]);
    });

    return rows;
  }

  buildFlatRow(
    family: string,
    model: string,
    unit: string,
    compType: string,
    comp: string,
    monthsData: any[],
  ) {
    const row = [family, model, unit, compType, comp];

    this.months.forEach((m) => {
      const data = monthsData?.find((x) => x.MonthNo === m.MonthNo) || {};

      if (this.showCracks) row.push(data.TotalCracks || 0);
      if (this.showLength) row.push(data.TotalLength || 0);
      if (this.showRecracks) row.push(data.TotalRecracks || 0);
    });

    return row;
  }
}
